import React from 'react';
import styles from './CurrencyInput.module.sass';

import currency from '../../../../utils/currency';

const currencyInput = (props) => {

    const formatInput = (event) => {
        const value = event.target.value.replace(',', '').split('.').join('');
        if (!isNaN(value) && props.hasOwnProperty('onChange')) {
            props.onChange(currency.numberToCurrency(value/100));
        }
    };

    return (
        <div tabIndex="0" className={styles.inputGroup + (props.valid ? '' : ' ' + styles.error)}>
            <div className={styles.inputDetail}>
              <span className={styles.detail}>R$</span>
            </div>
            <input {...props} valid=''
              className={styles.input} placeholder={'0,00'}
              onChange={formatInput}
              maxLength="18"
            />
        </div>
    );
};

export default currencyInput;
